export default "__VITE_ASSET__BwnWDqCF__"